<template>
  <BasicTooltip
    v-if="isNotAllowed"
    :label
    :position="toolTipPosition"
  >
    <slot :isNotAllowed />
  </BasicTooltip>

  <slot
    v-else
    :isNotAllowed
  />
</template>

<script lang="ts" setup>
  import type { WrapperPermissionsProps } from './WrapPermissions.types'
  import { useAppStateStore } from '@/features/application'
  import { computed } from 'vue'

  const props = withDefaults(defineProps<WrapperPermissionsProps>(), {
    toolTipPosition: 'bottom',
    label: "Vous n'êtes pas autorisé à effectuer cette action",
  })

  const appState = useAppStateStore()

  const isAllowed = computed(() =>
    (Array.isArray(props.permissions) ? props.permissions : [props.permissions])
      .map((p) => appState.getPermissions(p))
      .some((n) => n === 'Ecriture'),
  )

  const isNotAllowed = computed(() => !isAllowed.value)
</script>
